import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { BILLING_CONFIG } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetExecutionByPricingIdProps {
  pricingId: any;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getExecutionByPricingId = async (communityId: string, pricingId: any) =>
  await axiosAuth.get(
    `${BILLING_CONFIG(communityId)}/${pricingId}/executions/`
  );

const useGetExecutionByPricingId = ({
  pricingId,
  communityId,
  queryParams,
}: UseGetExecutionByPricingIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["billing-config-execution", communityId, pricingId],
    queryFn: () => getExecutionByPricingId(communityId, pricingId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && !!pricingId && (queryParams?.enabled ?? true),
  });
};

export default useGetExecutionByPricingId;
